import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction-to-features"
    }}>{`Introduction to Features`}</h1>
    <p>{`In this chapter we will mainly discuss about how we can build pages more specially to fullfill our needs.`}</p>
    <h2 {...{
      "id": "manage-faqs"
    }}>{`Manage FAQs`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`FAQs`}</inlineCode>{` menu super admin will get the form to add, remove or modify FAQs from there. In vendor end, shop owner can also add specific FAQs based on their specific shop.`}</p>
    <blockquote>
      <p parentName="blockquote">{`For More Details `}<a parentName="p" {...{
          "href": "/faq-page"
        }}>{`FAQS`}</a></p>
    </blockquote>
    <h2 {...{
      "id": "manage-terms--conditions"
    }}>{`Manage Terms & Conditions`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`Terms & Conditions`}</inlineCode>{`  menu super admin will get the form to add, remove or modify terms & conditions from there. There are some keynotes about this,`}</p>
    <ul>
      <li parentName="ul">{`Super admin can enable the accessibility for vendors to add terms & conditions.`}</li>
      <li parentName="ul">{`Vendor's added terms & conditions must have to go through approval phase via Super admin.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`For More Details `}<a parentName="p" {...{
          "href": "/terms-and-conditions"
        }}>{`Terms & Conditions`}</a></p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      